import type { FC } from "react";
import { AssistantAvatarHair } from "@/ui/AssistantAvatar/assistantAvatarConfig";
import { pointsOnArc } from "@/ui/AssistantAvatar/assistantAvatarGeometry";

type HairLayer = FC<{ color: string }>;

// Curls ring the head from lower-left, over the top, to lower-right; the chin side stays open.
const CURLS = pointsOnArc(60, 54, 27, 140, 400, 20);

/** The hair layer behind the head. Short and buzz cuts have none. */
const HAIR_BACK: Record<AssistantAvatarHair, HairLayer | null> = {
	[AssistantAvatarHair.Short]: null,
	[AssistantAvatarHair.Buzz]: null,
	[AssistantAvatarHair.Bob]: ({ color }) => <path d="M33 60 C30 34 44 24 60 24 C76 24 90 34 87 60 L89 86 Q60 94 31 86 Z" fill={color} />,
	[AssistantAvatarHair.Long]: ({ color }) => <path d="M31 60 C28 30 44 21 60 21 C76 21 92 30 89 60 L93 114 Q60 122 27 114 Z" fill={color} />,
	[AssistantAvatarHair.Curly]: ({ color }) => (
		<>
			{CURLS.map(({ x, y }) => (
				<circle key={`${x}-${y}`} cx={x} cy={y} r={10} fill={color} />
			))}
		</>
	),
	[AssistantAvatarHair.Bun]: ({ color }) => <circle cx={60} cy={22} r={11} fill={color} />,
};

export const HumanHairBack: FC<{ hair: AssistantAvatarHair; color: string }> = ({ hair, color }) => {
	const Layer = HAIR_BACK[hair];
	return Layer ? <Layer color={color} /> : null;
};
